import React from 'react';

const Terms = () => {
  const styles = {
    container: {
      marginTop: '115px',
      maxWidth: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '20px',
      lineHeight: '1.6',
      color: '#333',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    },
    heading: {
      color: '#2c3e50',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    section: {
      marginBottom: '25px'
    },
    h2: {
      color: '#3498db',
      fontSize: '1.3rem',
      marginBottom: '10px'
    },
    p: {
      marginBottom: '15px'
    },
    ul: {
      paddingLeft: '20px',
      marginBottom: '15px'
    },
    li: {
      marginBottom: '8px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Terms of Service</h1>
      <p style={styles.p}>Last Updated: January 1, 2023</p>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>1. Acceptance of Terms</h2>
        <p style={styles.p}>By accessing or using any services provided by PCDS Infotech ("we", "us", or "our"), you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, you may not access the website or use any services.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>2. Description of Services</h2>
        <p style={styles.p}>PCDS Infotech provides digital solutions including but not limited to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Web development and redesign services</li>
          <li style={styles.li}>E-commerce solutions</li>
          <li style={styles.li}>Mobile application development</li>
          <li style={styles.li}>AI-based solutions for various industries</li>
          <li style={styles.li}>IT consulting services</li>
          <li style={styles.li}>Web maintenance and promotion</li>
        </ul>
        <p style={styles.p}>All services are subject to change or discontinuation without notice at our sole discretion.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>3. User Responsibilities</h2>
        <p style={styles.p}>As a user of our services, you agree to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Provide accurate and complete information when required</li>
          <li style={styles.li}>Maintain the confidentiality of your account credentials</li>
          <li style={styles.li}>Notify us immediately of any unauthorized use of your account</li>
          <li style={styles.li}>Use the services only for lawful purposes</li>
          <li style={styles.li}>Not interfere with or disrupt the services or servers</li>
          <li style={styles.li}>Not attempt to gain unauthorized access to any systems or networks</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>4. Intellectual Property</h2>
        <p style={styles.p}>All content included on our website and delivered through our services, including text, graphics, logos, images, and software, is the property of PCDS Infotech or its content suppliers and protected by copyright and other laws.</p>
        <p style={styles.p}>For services involving custom development, intellectual property rights will be transferred to the client upon full payment, unless otherwise agreed in writing.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>5. Payments and Refunds</h2>
        <p style={styles.p}>All services require payment as per the agreed terms. We accept various payment methods including credit cards, bank transfers, and online payment systems.</p>
        <p style={styles.p}>Refund policies vary by service and will be specified in your service agreement. Generally:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Custom development projects may have milestone-based payments with limited refund options</li>
          <li style={styles.li}>Subscription services may be canceled with prorated refunds</li>
          <li style={styles.li}>No refunds are provided for services already rendered</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>6. Limitation of Liability</h2>
        <p style={styles.p}>In no event shall PCDS Infotech, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Your access to or use of or inability to access or use the services</li>
          <li style={styles.li}>Any conduct or content of any third party on the services</li>
          <li style={styles.li}>Any content obtained from the services</li>
          <li style={styles.li}>Unauthorized access, use or alteration of your transmissions or content</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>7. Termination</h2>
        <p style={styles.p}>We may terminate or suspend your account and bar access to the services immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>
        <p style={styles.p}>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>8. Governing Law</h2>
        <p style={styles.p}>These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
        <p style={styles.p}>Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in Mumbai, Maharashtra.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>9. Changes to Terms</h2>
        <p style={styles.p}>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect.</p>
        <p style={styles.p}>By continuing to access or use our services after those revisions become effective, you agree to be bound by the revised terms.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>10. Contact Information</h2>
        <p style={styles.p}>For any questions about these Terms, please contact us:</p>
        <p style={styles.p}>By email: legal@pcds.in</p>
        <p style={styles.p}>By visiting this page on our website: www.pcds.in/contact</p>
        <p style={styles.p}>By mail: 1st Floor Mukta Tawar, Near Andheri Station, Andheri West, Mumbai - 400058</p>
      </section>
    </div>
  );
};

export default Terms;